// removed by extract-text-webpack-plugin
module.exports = {"form":"_35I6s40HQiFZG-Zr8-speT","header":"_8w2aXTlrvfXf0S0eOzYUA","button":"_5Z_CzdJnblSTpU_f0wsEp"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/Info/ManualForm.css
// module id = 203
// module chunks = 0